import { render, staticRenderFns } from "./SelectLabel.vue?vue&type=template&id=404fd500&scoped=true&"
import script from "./SelectLabel.vue?vue&type=script&lang=ts&"
export * from "./SelectLabel.vue?vue&type=script&lang=ts&"
import style0 from "./SelectLabel.vue?vue&type=style&index=0&id=404fd500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404fd500",
  null
  
)

export default component.exports